import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "home",
    component: () =>
      import(/* webpackChunkName: "home" */ "@/views/home/Home.vue"),
    meta: {
      title: "Kareem Saber",
    },
  },
  {
    path: "/about",
    name: "about",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/AboutView.vue"),
    meta: {
      title: "About",
    },
  },
  {
    path: "/projects",
    name: "projects",
    component: () =>
      import(/* webpackChunkName: "projects" */ "@/views/ProjectsView.vue"),
    meta: {
      title: "Projects",
    },
  },
  {
    path: "/experience",
    name: "experience",
    component: () =>
      import(/* webpackChunkName: "experience" */ "@/views/ExperienceView.vue"),
    meta: {
      title: "Experience",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkExactActiveClass: "active",
});

router.beforeEach((to) => {
  document.title = to.meta.title;
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

export default router;
